var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","position":"relative"}},[_c('common-header'),_c('AnswerPublicBackground',[_c('my-keep-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }